import { TOOLS_DATA } from '../data/toolsData';

export default function ToolsPage({ setCurrentPage }) {
  const toolCategories = ['バイタルサイン・急変', '褥瘡・栄養', 'ADL・認知', '輸液・水分管理', '感染対策'];
  const toolCategoryStyles = {
    'バイタルサイン・急変': { border: 'border-red-400', dot: 'bg-red-400' },
    '褥瘡・栄養': { border: 'border-amber-400', dot: 'bg-amber-400' },
    'ADL・認知': { border: 'border-blue-400', dot: 'bg-blue-400' },
    '輸液・水分管理': { border: 'border-green-400', dot: 'bg-green-400' },
    '感染対策': { border: 'border-purple-400', dot: 'bg-purple-400' },
  };

  return (
    <div className="max-w-3xl mx-auto px-4 py-12">
      <h1 className="text-2xl font-bold text-gray-800 mb-2">ツール一覧</h1>
      <p className="text-gray-500 text-sm mb-8">臨床で使える看護師向けアセスメントツールをまとめています。</p>
      {toolCategories.map(cat => {
        const tools = TOOLS_DATA.filter(t => t.category === cat);
        const style = toolCategoryStyles[cat];
        return (
          <div key={cat} className="mb-8">
            <h2 className={`text-base font-bold text-gray-800 border-l-4 ${style.border} pl-3 mb-3`}>{cat}</h2>
            <div className="flex flex-wrap gap-x-1 gap-y-1">
              {tools.map((tool, i) => (
                <span key={tool.id}>
                  <button
                    onClick={() => {
                      if (!tool.available) return;
                      if (tool.externalUrl) {
                        window.open(tool.externalUrl, '_blank', 'noopener,noreferrer');
                      } else if (tool.page) {
                        setCurrentPage(tool.page);
                      }
                    }}
                    className="text-sm text-green-800 hover:text-green-600 hover:underline transition-colors"
                  >
                    {tool.title.replace('算出ツール', '').replace('計算ツール', '').replace('ツール', '').replace('　', ' ').trim()}
                  </button>
                  {i < tools.length - 1 && <span className="text-gray-300 mx-1">/</span>}
                </span>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}
